<template>
  <div
    class="modal"
    id="Modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div id="ModalContent" class="modal__content modal__content--md">
      <div class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200">
        <h2 class="font-medium text-base mr-auto">
          {{ socialreason.name }}
        </h2>
        <button type="button" class="close" @click="$emit('closeModal')">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div
        v-if="message"
        class="p-5 bg-yellow-500 text-yellow-100"
        role="alert"
      >
        {{ message }}
      </div>
      <form
        @submit.prevent="confirmation = true"
        enctype="multipart/form-data"
        class="form-task"
        v-if="!confirmation"
      >
        <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
          <div class="col-span-12 sm:col-span-12">
            <label>Moneda</label>
            <div class="input w-full border mt-2 flex-1">USD - $1</div>
          </div>
          <div class="col-span-12 sm:col-span-12">
            <label>Moneda cambio</label>
            <div class="input w-full border mt-2 flex-1">
              {{ socialreason.money }}
            </div>
          </div>
          <div class="col-span-12 sm:col-span-12">
            <label>1 dólar es igual a:</label>
            <input
              type="number"
              class="input w-full border mt-2 flex-1"
              step=".01"
              v-model="change.change"
              required
            />
          </div>
          <div class="col-span-12 sm:col-span-12">
            <label>Seleccionar mes:</label>
            <select
              class="input w-full border mt-2 flex-1"
              v-model="change.month"
              required
            >
              <option :value="null" disabled>Seleccionar...</option>
              <option v-for="index in 12" :key="index" :value="index">
                {{ index }}
              </option>
            </select>
          </div>
          <div class="col-span-12 sm:col-span-12">
            <label>Seleccionar año:</label>
            <select
              class="input w-full border mt-2 flex-1"
              v-model="change.year"
              required
            >
              <option :value="null" disabled>Seleccionar...</option>
              <option value="2026">2026</option>
              <option value="2027">2027</option>
            </select>
          </div>
        </div>
        <div class="px-5 py-3 text-right border-t border-gray-200">
          <button
            type="button"
            @click="$emit('closeModal')"
            class="button w-20 border text-gray-700 mr-1"
          >
            Cancelar
          </button>
          <button type="submit" class="button w-20 bg-theme-1 text-white">
            Actualizar
          </button>
        </div>
      </form>
      <div v-else>
        <div class="p-6">
          Está seguro de guardar el TRM de este mes donde un Dólar $1 equivale a
          {{ change.change }} {{ socialreason.money }} ?
        </div>
        <div class="px-5 py-3 text-right border-t border-gray-200">
          <button
            type="button"
            @click="confirmation = false"
            class="button w-20 border text-gray-700 mr-1"
          >
            Cancelar
          </button>
          <button
            type="button"
            @click="updateTrmChange()"
            class="button w-20 bg-theme-1 text-white"
          >
            Confirmar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/admin/partials/LoadingWhite'
import { mapActions } from 'vuex'

export default {
  name: 'TrmChangeModal',
  props: ['socialreason', 'message'],
  data() {
    return {
      errors: [],
      change: {
        social_reason_id: null,
        change: null,
        month: null,
        year: null,
        entity: 'trmchange',
      },
      confirmation: false,
    }
  },
  async beforeMount() {
    document.body.className = 'overflow-hidden'
  },
  beforeDestroy() {
    document.body.classList.remove('overflow-hidden')
  },
  methods: {
    updateTrmChange() {
      let vm = this
      vm.change.social_reason_id = this.socialreason.id
      vm.loading = false
      vm.store(vm.change)
        .then((item) => {
          vm.boxedit = false
          window.location.reload()
        })
        .catch((message) => {
          console.log(message)
        })
        .finally(() => {
          vm.loading = true
        })
    },
    ...mapActions(['store']),
  },
  components: {
    appLoading: Loading,
  },
}
</script>

<style>
#Modal {
  visibility: initial;
  opacity: unset;
  z-index: 100000000000;
  margin: unset;
  display: flex;
}

#ModalContent {
  margin-top: auto;
  margin-bottom: auto;
}
</style>



// WEBPACK FOOTER //
// TrmChangeModal.vue?20ba1632